
export const DownArrowAltIcon = ({ size = 40, stroke, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M30 15L20 25L10 15" stroke={stroke || 'black'} strokeWidth="3" />
  </svg>
)
